import * as React from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import {APPLY_CATEGORY} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {getFormattedDate} from '../../contactAddressOnEmergencies/helper/NatContactAddressOnEmergencyHelper'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {getFormattedYearMonth} from '../helper/NatParkingUsesWithdrawalHelper';

interface Props {
    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    withdrawalArea: Nullable<string>
    withdrawalDate: Nullable<string>
    carCarryingOutDate: Nullable<string>
    applyFlag?: boolean
}

const NatResidentParkingUsesWithdrawalConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {
        applicantFamilyName, applicantFirstName, withdrawalArea,
        withdrawalDate, carCarryingOutDate
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.PARKING_USE_CANCEL.label

    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )
    const withdrawalAreaLabel = withdrawalArea ?? ''

    const withdrawalDateLabel = (withdrawalDate) ?
        getFormattedYearMonth(withdrawalDate) : ''

    const carCarryingOutDateLabel = (carCarryingOutDate) ?
        getFormattedDate(carCarryingOutDate) : ''

    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
            </>
        }
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'解約する区画'}
            items={[`${withdrawalAreaLabel}`]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'解約日'}
            items={[withdrawalDateLabel]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'自動車搬出日'}
            items={[carCarryingOutDateLabel]}
        />
        <BlockSpacer height={'5px'}/>
    </>)
}

NatResidentParkingUsesWithdrawalConfirm.displayName = 'NatResidentParkingUsesWithdrawalConfirm'
export default NatResidentParkingUsesWithdrawalConfirm